import { render, staticRenderFns } from "./ProductWhiteListCreate.vue?vue&type=template&id=46e6187b&"
import script from "./ProductWhiteListCreate.vue?vue&type=script&lang=js&"
export * from "./ProductWhiteListCreate.vue?vue&type=script&lang=js&"
import style0 from "./ProductWhiteListCreate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports